import { render } from "./Home.vue?vue&type=template&id=04b09ee4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=04b09ee4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04b09ee4"

export default script